import { Link } from "react-router-dom";
import { Row, Col, Card, Button, Statistic, Badge } from "antd";
import { SettingOutlined } from "@ant-design/icons";

import {
  projectSubgraphsPath,
  projectSettingsPath,
  projectEndpointPath,
} from "../../helpers/paths";

interface Project {
  id: string;
  name: string;
  identifier: string;
  createdAt: number;
  subgraphsCount: number;
  mainnetEndpointActive: boolean;
  mainnetArchiveEndpointActive: boolean;
  testnetEndpointActive: boolean;
  testnetArchiveEndpointActive: boolean;
}

export function ProjectCardItem(props: { project: Project }) {
  const project = props.project;

  return (
    <Card
      className={"card-body"}
      title={project.name}
      extra={
        <Link to={projectSettingsPath(project.id)}>
          <Button>
            <SettingOutlined /> Settings
          </Button>
        </Link>
      }
    >
      <Row gutter={16}>
        <Col span={8}>
          <Statistic
            title="Subgraphs"
            value={project.subgraphsCount}
            formatter={(value) => {
              return <Link to={projectSubgraphsPath(project.id)}>{value}</Link>;
            }}
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="Cronos RPC Status"
            value={""}
            formatter={(value) => {
              return (
                <Row gutter={{ xs: 8, sm: 16, md: 36 }}>
                  <Col md={12} xs={24}>
                    <Link to={projectEndpointPath(project.id, "cronos", "mainnet", "shared")}>
                      <Button size="small">
                        <Badge
                          status={project.mainnetEndpointActive ? "success" : "error"}
                          text="Mainnet"
                        />
                      </Button>
                    </Link>
                  </Col>
                  <Col md={12} xs={24}>
                    <Link to={projectEndpointPath(project.id, "cronos", "mainnet", "archive")}>
                      <Button size="small">
                        <Badge
                          status={project.mainnetArchiveEndpointActive ? "success" : "error"}
                          text="Mainnet Archive"
                        />
                      </Button>
                    </Link>
                  </Col>
                  <Col md={12} xs={24}>
                    <Link to={projectEndpointPath(project.id, "cronos", "testnet", "shared")}>
                      <Button size="small">
                        <Badge
                          status={project.testnetEndpointActive ? "success" : "error"}
                          text="Testnet"
                        />
                      </Button>
                    </Link>
                  </Col>
                  <Col md={12} xs={24}>
                    <Link to={projectEndpointPath(project.id, "cronos", "testnet", "archive")}>
                      <Button size="small">
                        <Badge
                          status={project.testnetArchiveEndpointActive ? "success" : "error"}
                          text="Testnet Archive"
                        />
                      </Button>
                    </Link>
                  </Col>
                </Row>
              );
            }}
          />
        </Col>
      </Row>
    </Card>
  );
}
